export const getArrayRange = (start, end) => {
    return Array(end - start + 1)
        .fill(0)
        .map((_, idx) => start + idx);
};
export const groupBy = (list, getKey) => list.reduce((previous, currentItem) => {
    const group = getKey(currentItem);
    if (!previous[group])
        previous[group] = [];
    previous[group].push(currentItem);
    return previous;
}, {});
export const sortDateFunction = (a, b) => {
    const dateA = new Date(a).getTime();
    const dateB = new Date(b).getTime();
    return dateA > dateB ? 1 : -1;
};
export const flatArray = (array) => {
    return array.reduce((acc, val) => acc.concat(val), []);
};
export const mapArrayToObject = (array, key) => {
    const initialValue = {};
    return array.reduce((obj, item) => {
        return Object.assign(Object.assign({}, obj), { [item[key]]: item });
    }, initialValue);
};
export function chunkArray(array, size) {
    if (!Array.isArray(array)) {
        return undefined;
    }
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
        chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
}
//# sourceMappingURL=array-utils.js.map